import React from "react";
import { Typography, Grid, Container } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { CustomAppBar, CustomButton } from "../../../shared";
import { styleSheet } from "../../../assets/theme";
import { getContent } from "../../../utils/helper";
import { supportedLanguageMapping } from "../../language/constants";
import { addressVerificationSteps } from "../constants";

const styles = {
   options: {
      marginTop: "5%",
      textTransform: "none",
      fontWeight: "normal",
      textAlign: "center",
      width: "100%",
      padding: "5%",
      border: "1px solid #33cccc",
      borderRadius: 10,
      boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
   },
};

const AddressVerification = ({
   goBack,
   goToScreen,
   language,
   languageJSON,
   step,
   handleChange,
   selectedVerificationOption,
   goNext,
   addressVerificationOptions,
   requestDetails,
   handleConfirmation,
}) => {
   return (
      <div>
         <CustomAppBar
            title={getContent(languageJSON, "title_address_verification")}
            leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
            rightButton={
               <CustomButton
                  variant="text"
                  color="primary"
                  handleChange={() => goToScreen("language", { to: "addressVerification" })}
                  label={supportedLanguageMapping[language]}
               />
            }
         />
         {[
            addressVerificationSteps.AVAILABILITY_AT_ADDRESS,
            addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS,
            addressVerificationSteps.VERIFICATION_DENIAL,
         ].indexOf(step) > -1 ? (
            <Container>
               <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={{ padding: "2%", maxHeight: "100vh", overflow: "scroll", paddingBottom: 150 }}
                  spacing={
                     [
                        addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS,
                        addressVerificationSteps.VERIFICATION_DENIAL,
                     ].indexOf(step) > -1
                        ? 2
                        : null
                  }
               >
                  <Grid item xs={11}>
                     <Typography variant="h6">
                        {getContent(
                           languageJSON,
                           addressVerificationSteps.AVAILABILITY_AT_ADDRESS
                              ? "text_available_address"
                              : addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS
                              ? "subtitle_select_not_at_address"
                              : "subtitle_no_verification"
                        )}
                     </Typography>
                  </Grid>
                  <Grid
                     item
                     xs={11}
                     style={{ backgroundColor: "#fff", padding: "4% 6%", margin: "5%", border: "1px dashed #33cccc" }}
                  >
                     <Typography variant="subtitle1">
                        {((requestDetails || {}).additionalParams || {}).address}
                     </Typography>
                  </Grid>
                  <Grid item xs={11} style={{ marginTop: "5%" }}>
                     {Object.values(addressVerificationOptions[step]).map((item, index) => (
                        <CustomButton
                           key={index}
                           style={{
                              ...styles.options,
                              backgroundColor:
                                 selectedVerificationOption === item ? styleSheet.palette.primary.main : "#fff",
                              color:
                                 selectedVerificationOption === item ? styleSheet.palette.primary.contrastText : "#000",
                           }}
                           label={item}
                           handleChange={() => handleChange("selectedVerificationOption", item)}
                        />
                     ))}
                  </Grid>
               </Grid>
            </Container>
         ) : null}
         {[
            addressVerificationSteps.AVAILABILITY_AT_ADDRESS,
            addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS,
            addressVerificationSteps.VERIFICATION_DENIAL,
         ].indexOf(step) > -1 && selectedVerificationOption ? (
            <Grid
               container
               justify="center"
               alignItems="center"
               style={{ padding: "15px", position: "absolute", bottom: 0, left: 0, backgroundColor: "#f7fdfd" }}
            >
               <Grid item xs={11}>
                  <CustomButton
                     size="large"
                     variant="contained"
                     style={{ textAlign: "center", width: "100%", fontSize: 12 }}
                     color="primary"
                     handleChange={
                        [
                           addressVerificationSteps.NON_AVAILABILITY_AT_ADDRESS,
                           addressVerificationSteps.VERIFICATION_DENIAL,
                        ].indexOf(step) > -1
                           ? handleConfirmation
                           : goNext
                     }
                     label={<Typography variant="button">{getContent(languageJSON, "action_next")}</Typography>}
                  />
               </Grid>
            </Grid>
         ) : null}
      </div>
   );
};

export default AddressVerification;